export default __webpack_public_path__ + "static/media/gail.1ea21487.png";